<template>
  <List />
</template>

<script>
import List from '@/components/customers/List'

export default {
  components: { List }
}
</script>
